module.exports = __webpack_public_path__ + "media/images/login-bonus-kv-37d2b6654b094e59754a252eabb0db88.png";